import React from 'react'
import {
  If,
} from '@paytrace/pt-skel/Component'
import { SortIcon } from './Icons'
import {
  SortConfig,
} from '../Helper/ViewTransactions'

interface TableHeaderColumn {
  key: string,
  component: React.ReactNode,
  sort?: 'asc' | 'desc' | null
  span?: number,
  sortable?: boolean,
}

interface TableHeaderProps {
  headings: TableHeaderColumn[]
  onHeaderSortToggle?: (id: string) => void
  onHeaderCheckboxToggle?: (id: string, checked: boolean) => void
  sortConfig: SortConfig | null
}

function TableHeader (props: TableHeaderProps) {
  const handleClickEvent = (e: React.MouseEvent<HTMLTableCellElement>) => {
    if (props.onHeaderSortToggle) {
      e.stopPropagation()
      const id = e.currentTarget.id
      props.onHeaderSortToggle(id)
    }
  }

  return (
    <thead>
      <tr className="headers-row">
        {props.headings.map((item, idx) => (
          <th id={item.key} key={`${item.key}-{idx}`} colSpan={item.span} onClick={handleClickEvent}>
            <span className={ item.sortable ? 'sortable-header-content' : '' }>
              {item.component}
              <If is={item.sortable}>
                <SortIcon state={
                  props.sortConfig?.column === item.key ? props.sortConfig.direction : 'unsorted'
                } />
              </If>
            </span>
          </th>
        ))}
      </tr>
    </thead>
  )
}

export {
  type TableHeaderColumn,
  type TableHeaderProps,
  TableHeader,
}
